module.exports = __webpack_public_path__ + "static/media/smallMedal_3.cb93d204.png";